<script>
export default {
  name: 'CostItemSelect',
  components: {},
  props: {
    value: {
      type: [String, Number, Array],
      default: null
    },
    allowCreate: {
      type: Boolean,
      default: false
    },
    createTaxRate: {
      type: Number,
      default: 0
    },
    defaultByLabel: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      options: [],
      createdLabel: null,
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.value || this.createdLabel;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  mounted() {
    this.initOptions();
  },
  methods: {
    initOptions() {
      this.loading = true;
      this.$store.dispatch('bu_costItem/fetchOptions', {
        page: 1,
        size: 999
      }).then(res => {
        this.options = res.data.records || [];
        if (this.defaultByLabel) {
          const defaultItem = this.options.find(item => item.costItemName === this.defaultByLabel);
          if (defaultItem) {
            this.$nextTick(() => {
              this.selectedValue = defaultItem.id;
            })
          }
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    onChange(val) {
      if (Object.hasOwn(this.$attrs, 'multiple')) {
        const selectedItems = val.map(item => this.options.find(option => option.id === item));
        this.$emit('change', selectedItems);
      } else {
        let selectedItem = this.options.find(item => item.id === val);
        if (!selectedItem && this.allowCreate) {
          selectedItem = {
            id: null,
            costItemName: val,
            costItemTaxRate: this.createTaxRate
          }
          this.createdLabel = val;
          this.$emit('input', null);
          this.$emit('change', selectedItem);
          this.$emit('update:costItemName', selectedItem.costItemName);
          this.$emit('update:costItemTaxRate', selectedItem.costItemTaxRate);
          return;
        }
        this.$emit('change', selectedItem);
        this.$emit('update:costItemName', selectedItem ? selectedItem.costItemName : null);
        this.$emit('update:costItemTaxRate', selectedItem ? selectedItem.costItemTaxRate : null);
      }
    }
  }
}
</script>

<template>
  <el-select
    v-model="selectedValue"
    :loading="loading"
    v-bind="$attrs"
    @change="onChange"
    :allow-create="allowCreate"
    filterable
    default-first-option
    clearable
    style="width: 100%;"
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.costItemName"
      :value="item.id"
    >
      <div>
        <div class="flex justify-between">
          <div>
            <span>{{ item.costItemName }}</span>
          </div>
          <div>
            <span class="label">税率：</span>
            <span>{{ _.isNil(item.costItemTaxRate) ? '-' : item.costItemTaxRate }}%</span>
          </div>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<style scoped lang="scss">
.label {
  font-size: 12px;
  color: var(--color-text-3);
}
</style>
